import React from 'react';

const Completed = () => {
    return ( <>
<div className="mb-8">
          <div className="font-bold text-3xl">Thank you for enrolling in your benefits.</div>
          <div className="font-bold text-3xl">Your selections have been submitted.</div>
        </div> 
        <p className='my-8'>
        <strong>Questions?</strong>  Contact Beth Mellenthin  at 314-592-2206 or Sara Benignus at 314-492-2566 or e-mail <a href='mailto:benefits@claycorp.com'>benefits@claycorp.com</a> . 
        </p>
   
        </> );
}
 
export default Completed;